import VentaCargadeCodigos from "./VentaCodigoCargado";

export default VentaCargadeCodigos;
